// Language is determined exclusively by the hostname, never by browser settings.
export function getLanguage(hostname = window.location.hostname) {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  return host === 'soft99garage.de' || host.endsWith('.soft99garage.de') ? 'de' : 'pl';
}

export const language = getLanguage();
export const cmsLocale = language === 'de'
  ? (process.env.REACT_APP_STRAPI_LOCALE_DE || 'de')
  : 'pl-PL';
